import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue-demi';
import AbLink from '../AbLink/AbLink.vue';

interface Props {
  placeholder?: string;
  options: {
    value?: any;
    link?: string;
    text: string;
  }[];
}
interface Emits {
  (e: 'selectItem', data: any): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AbDropdown',
  props: {
    placeholder: null,
    options: null
  },
  emits: ["selectItem"],
  setup(__props: any) {

const dropdownRef = ref();



const setDropdownPopupMinWidthPercentage = (width: number) => {
  const dropdownInner = dropdownRef.value.shadowRoot.querySelector('#dropdown');
  const dropdownPopup =
    dropdownInner.shadowRoot.querySelector('[part="popup"]');
  dropdownPopup.style.minWidth = `${width}%`;
};
onMounted(async () => {
  if (typeof window !== 'undefined') {
    await import('@shoelace-style/shoelace/dist/components/dropdown/dropdown');
    await import('@shoelace-style/shoelace/dist/components/button/button');
    await import('@shoelace-style/shoelace/dist/components/menu/menu');
    await import(
      '@shoelace-style/shoelace/dist/components/menu-item/menu-item'
    );
  }
  setDropdownPopupMinWidthPercentage(100);
});

return { __sfc: true,dropdownRef, setDropdownPopupMinWidthPercentage, AbLink }
}

})